import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = { bookingKey: String }

  connect() {
    this.storageKey = `payment-status-refreshes:${this.bookingKeyValue}`
    const attempts = Number(window.sessionStorage.getItem(this.storageKey) || 0)

    if (attempts >= 20) {
      this.messageTarget.textContent =
        "Confirmation is taking longer than usual. Check your dashboard in a few minutes or contact support with this reference."
      return
    }

    window.sessionStorage.setItem(this.storageKey, attempts + 1)
    this.timer = window.setTimeout(() => window.location.reload(), 3000)
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer)
  }
}
